import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { GetUserRatingsResponseDto } from "../generated/generatedTypes";

const fetchUserRatings = async (userId: string): Promise<GetUserRatingsResponseDto> => {
  const response = await apiFetch(`api/admin/users/${userId}/ratings`);
  if (!response.ok) {
    throw new Error("사용자 평가를 불러오지 못했습니다.");
  }
  return response.json();
};

export const useGetUserRatings = (userId: string, enabled: boolean) => {
  return useQuery({
    queryKey: ["user-ratings", userId],
    queryFn: () => fetchUserRatings(userId),
    enabled,
  });
};
